import * as React from "react";
import type { SVGProps } from "react";
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.629 16.101H4.555c-1.948 0-3.526-1.328-3.526-3.276A3.527 3.527 0 0 1 4.947 9.32V9.3h.048a6.27 6.27 0 0 1 11.685-3.86q.395-.059.806-.059a5.486 5.486 0 0 1 5.485 5.486c0 2.764-2.043 4.8-4.702 5.18h-2.84m-3.82-6.355v12.063m0 0-2.78-2.708m2.78 2.708 2.705-2.708"
    />
  </svg>
);
export default SvgDownload;
